module.exports = __webpack_public_path__ + "static/media/log-SKY.2b442a5d.svg";